import * as Types from './types'

export const IMAGE_SERVER_RESOURCE = 'https://image-api.rasa.io/image/hosted-images-newsbrief/path'

export const socialMediaKeys: Types.SocialMediaKey[] = [
  { key: 'twitter_icon_link', displayName: 'Twitter', iconName: 'twitter'},
  { key: 'facebook_icon_link', displayName: 'Facebook', iconName: 'facebook'},
  { key: 'linkedin_icon_link', displayName: 'LinkedIn', iconName: 'linkedin'},
  { key: 'instagram_icon_link', displayName: 'Instagram', iconName: 'instagram'},
  { key: 'youtube_icon_link', displayName: 'YouTube', iconName: 'youtube'},
]

export const UPDATE_URL_FIELD = 'UPDATE_URL_FIELD'
export const UPDATE_SOCIAL_MEDIA_DROPDOWN = 'UPDATE_SOCIAL_MEDIA_DROPDOWN'

export const DELETE_ICON = 'DELETE_ICON'
export const ADD_ICON = 'ADD_ICON'



// WEBPACK FOOTER //
// ./src/pages/newsbrief/social-media/constants.ts